import { render, staticRenderFns } from "./TransitionCommentModal.vue?vue&type=template&id=31d308af&scoped=true"
import script from "./TransitionCommentModal.vue?vue&type=script&lang=js"
export * from "./TransitionCommentModal.vue?vue&type=script&lang=js"
import style0 from "./TransitionCommentModal.vue?vue&type=style&index=0&id=31d308af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d308af",
  null
  
)

export default component.exports